<template>
<!--	<transition enter-active-class="animated slideInLeft faster">-->
<!--		-->
<!--	</transition>-->
    <div class="sidebar" data-color="blue" data-active-color="warning">
        <!--
    Tip 1: You can change the color of the sidebar using: data-color="blue | green | orange | red | yellow"
-->
        <div class="logo">
            <a href="https://www.bigscoots.com/" class="simple-text logo-mini" v-if="sidebarMini === true">
                <div class="logo-image-small">
                    <img src="../../assets/img/bigscoots-logo/bigscoots-logo-mascot-white.svg">
                </div>
            </a>
            <a href="https://www.bigscoots.com/" target="_blank" class="simple-text" v-if="sidebarMini === false">
                <div class="logo-image-big">
                    <img src="../../assets/img/bigscoots-logo/logo_light.svg" alt="BigScoots" width="70%" class="center">
                </div>
            </a>
        </div>
        <div class="sidebar-wrapper">
            <div class="user">
                <div class="photo">
                    <img :src="`https://www.gravatar.com/avatar/${userEmailHash}?s=34`"/>
                </div>
                <div class="info">
                    <a data-toggle="collapse" href="#collapseExample" class="collapsed">
							<span>
								{{ userFullName }}
								<br>
								<small>{{ emailFormatter(userEmail) }}</small>
								<b class="caret"></b>
							</span>
                    </a>
                    <div class="clearfix"></div>
                    <div class="collapse" id="collapseExample">
                        <ul class="nav">
                            <router-link tag="li" :to="{ name: 'editAdminProfile' }" exact-active-class="active">
                                <a>
                                    <span class="sidebar-mini-icon">EP</span>
                                    <span class="sidebar-normal">Edit Profile</span>
                                </a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </div>
            <ul class="nav">
              <router-link tag="li" :to="{ name: 'adminDashboard' }" exact-active-class="active">
                  <a>
                      <i class="fa fa-home"></i>
                      <p>Dashboard</p>
                  </a>
              </router-link>
              <router-link tag="li" :to="{ name: 'statisticsPanel' }" exact-active-class="active">
                <a>
                  <i class="fa fa-bar-chart"></i>
                  <p>
                    Team Statistics
                  </p>
                </a>
              </router-link>
<!--              <router-link tag="li" :to="{ name: 'statisticsPanel' }" exact-active-class="active">-->
<!--                    <a>-->
<!--                      <i class="fa fa-bar-chart"></i>-->
<!--                        <p>Statistics Panel-->
<!--                        </p>-->
<!--                    </a>-->
<!--                </router-link>-->
                <router-link  tag="li" :to="{ name: 'adminLogs' }" exact-active-class="active">
                    <a>
                        <i class="fa fa-list"></i>
                        <p>Logs
<!--                          <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ apiErrorLogs.length }}</span>-->
                        </p>
                    </a>
                </router-link>
              <router-link  tag="li" :to="{ name: 'clientFeedback' }" exact-active-class="active">
                <a>
                  <i class="fa fa-bullhorn" aria-hidden="true"></i>
                  <p>Client Feedback
                    <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ activeFeedbacks.length }}</span>
                  </p>
                </a>
              </router-link>
<!--                <router-link  tag="li" :to="{ name: 'outages' }" exact-active-class="active">-->
<!--                    <a>-->
<!--                        <i class="fa fa-exclamation-triangle"></i>-->
<!--                        <p>Outages-->
<!--                          <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ testsOff.length }}</span>-->
<!--                        </p>-->
<!--                    </a>-->
<!--                </router-link>-->
              <router-link  tag="li" :to="{ name: 'betteruptime' }" exact-active-class="active">
                    <a>
                        <i class="fa fa-tv"></i>
                        <p>Monitors
                          <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ testGroups.length }}</span>
                        </p>
                    </a>
                </router-link>
<!--                <router-link tag="li" :to="{ name: 'createUser' }" exact-active-class="active">-->
<!--                    <a>-->
<!--                        <i class="fa fa-user-plus"></i>-->
<!--                        <p>Create New User</p>-->
<!--                    </a>-->
<!--                </router-link>-->
                <router-link v-if="user.userType === 'admin' ||  user.userType === 'super-admin'  " tag="li" :to="{ name: 'userList' }" exact-active-class="active">
                    <a>
                        <i class="fa fa-users"></i>
                        <p>User Management</p>
                    </a>
                </router-link>
<!--                <router-link v-if="user.userType === 'admin'" tag="li" :to="{ name: 'createAdminUser' }" exact-active-class="active">-->
<!--                    <a>-->
<!--                        <i class="fa fa-user-secret"></i>-->
<!--                        <p>Create Admin User</p>-->
<!--                    </a>-->
<!--                </router-link>-->
<!--                <router-link v-if="user.userType === 'admin'" tag="li" :to="{ name: 'adminsList' }" exact-active-class="active">-->
<!--                    <a>-->
<!--                        <i class="fa fa-users"></i>-->
<!--                        <p>Admins List</p>-->
<!--                    </a>-->
<!--                </router-link>-->
<!--                <router-link tag="li" :to="{ name: 'announcements' }" exact-active-class="active">-->
<!--                    <a>-->
<!--                        <i class="fa fa-bullhorn"></i>-->
<!--                        <p>Announcements</p>-->
<!--                    </a>-->
<!--                </router-link>-->
              <router-link tag="li" :to="{ name: 'communications' }" exact-active-class="active">
                <a>
                  <i class="fa fa-bullhorn"></i>
                  <p>Communications
                    <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ pendingTeamAnnouncements }}</span>
                  </p>
                </a>
              </router-link>
                <router-link tag="li" :to="{ name: 'tasks-queue' }" exact-active-class="active">
                    <a>
                        <i class="fa fa-tasks"></i>
                        <p>Sales <span class="badge badge-danger rounded-circle noti-icon-badge pull-right">{{activeSalesTasks}}</span></p>
                    </a>
                </router-link>
                <router-link tag="li" :to="{ name: 'support-tasks' }" exact-active-class="active">
                    <a>
                        <i class="fa fa-life-ring"></i>
                        <p>
                            Support
<!--                            <span class="badge badge-default rounded-circle noti-icon-badge pull-right">{{activeSupportTasks.nonUrgent}}</span>-->
                            <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{activeSupportTasks.urgent}}</span>
                        </p>
                    </a>
                </router-link>
                <router-link tag="li" :to="{ name: 'migration-tasks' }" exact-active-class="active">
                    <a>
                        <i class="fa fa-database"></i>
                        <p>
                            Migrations
                            <span class="badge badge-danger rounded-circle noti-icon-badge mr-3 pull-right">{{ activeMigrations }}</span>
                        </p>
                    </a>
                </router-link>
                <router-link tag="li" :to="{ name: 'sync-servers' }" exact-active-class="active">
                    <a>
                      <i class="fa fa-tasks"></i>
                        <p>
                            Plans
                        </p>
                    </a>
                </router-link>
              <router-link tag="li" :to="{ name: 'cloudflare' }" exact-active-class="active">
                    <a>
                      <i class="fa fa-tasks"></i>
                        <p>
                            Cloudflare
                        </p>
                    </a>
                </router-link>
<!--              <router-link tag="li" :to="{ name: 'statisticsPanel' }" exact-active-class="active">-->
<!--                <a>-->
<!--                  <i class="fa fa-bar-chart"></i>-->
<!--                  <p>-->
<!--                    statistics-panel-->
<!--                  </p>-->
<!--                </a>-->
<!--              </router-link>-->
              <router-link tag="li" :to="{ name: 'tools' }" exact-active-class="active">
                    <a>
                      <i class="fa fa-wrench"></i>
                        <p>
                            Tools
                        </p>
                    </a>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
	import $ from "jquery/dist/jquery.slim.min";
	import PerfectScrollbar from "perfect-scrollbar";
  import {db} from "@/firebase/init";
  import moment from "moment";
	let sidebar = null;

	export default {
		name: "AdminSideMenu",
    data () {
		  return {
        testsOff: [],
        betteruptimeTests: [],
        apiErrorLogs: [],
        testGroups: [],
        activeFeedbacks: [],
        clientFeedbackListener: null,
        pendingTeamAnnouncements: 0,
        annListener: null,
        currentToast: null,
        announcementElement : null
      }
    },
		computed: {
			sidebarMini() {
				return this.$store.getters["sidebarMini/type"]
			},
			userFullName() {
				return this.$store.getters.userFullName;
			},
			userEmail() {
				return this.$store.getters.userEmail;
			},
			userEmailHash() {
				return this.$store.getters.emailHashGravatar;
			},
			user() {
				return this.$store.getters.user;
			},
      getNotificationStatus(){
        return this.user.getNotificationStatus
      },
      activeSalesTasks () {
          return this.$store.getters['tasks/getActiveSalesTasksCount'];
      },
      activeSupportTasks () {
          return this.$store.getters['tasks/getActiveSupportTasksCount'];
      },
      activeMigrations () {
          return this.$store.getters['tasks/getActiveMigrationsCount'];
      },
		},
    watch: {
      async pendingTeamAnnouncements(val) {
        console.log('pending', val, this.currentToast)
        if (this.currentToast) {
          this.$toast.clear()
          this.currentToast = null;
        }
        if(val > 0 && this.getNotificationStatus) {
          await this.modelUp(val)
          console.log(this.currentToast)
        }
      }
    },
		mounted() {

			const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

			if (isWindows) {
				// if we are on windows OS we activate the perfectScrollbar function
				sidebar = new PerfectScrollbar(".sidebar .sidebar-wrapper");
				sidebar.update();
				//$('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();

				$("html").addClass("perfect-scrollbar-on");
			} else {
				$("html").addClass("perfect-scrollbar-off");
			}
			// this.getTotalDownOutages()
      this.getTotalDownBetterUptimeOutages()
      this.getPendingAnnouncements()
      this.getActiveFeedbacks()


      // this.getApiErrorLogs()
		},
    methods:{
      emailFormatter(email){
        if(email.length > 25){
          return `${email.slice(0,25)}...`
        }
        return email
      },
      getTotalDownOutages(){
        console.log('calling');

        this.testsOff = [];
        let downQuery = db.collection('status_cake_tests')
          .where('status', 'in', ['Down'])
          .limit(500);

        this.downListener = downQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':
                this.testsOff.unshift(change.doc.data());
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.testsOff = this.testsOff.filter(test => test.testId !== removedData.testId);
              }
                break;
            }
          });
        })
      },
      getActiveFeedbacks(){
        console.log('actiive feedback')
        this.activeFeedbacks = [];
        let query = db.collection('clientFeedbacks')
          .where('status', '==', 'pending')
          .limit(500);

        this.clientFeedbackListener = query.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            const data = change.doc.data();
            console.log(change.type)
            switch (change.type) {
              case 'added':
                if(data.status === 'pending') {
                  this.activeFeedbacks.push({id: change.doc.id, ...change.doc.data()});
                }
                break;
              case 'removed':
                this.activeFeedbacks = this.activeFeedbacks.filter(el => el.id !== change.doc.id);
                break;
            }
          });
        })
      },
      startGrouping () {
        this.testGroups=[]
        const testIps = ['69.162.173.212', '23.29.145.209']
        this.betteruptimeTests = this.betteruptimeTests.filter(test => {
          return !testIps.includes(test.serverIP)
        })
        this.betteruptimeTests.map(test => {
          const planName = test.hbSuspended ? 'Suspended' : ((test.plan) ? test.plan : '(N/A)');
          let group = this.testGroups.find(g => g.planName === planName);
          if(!group) {
            group = {
              planName:  planName,
              serverIP:  (planName === '(N/A)') ? '' :test.serverIP,
              tests: [test],
            };
            console.log('pushing')
            this.testGroups.push(group);
          } else if(group){
            const testExist = group.tests.find(t => (t.id === test.id));
            if(!testExist) {
              group.tests.push(test);
            }
          }
        });
      },
      async modelUp(counter){
        console.log('counter', counter);
        const message= `You haved <strong>${counter}</strong> unacknowledged team announcement${counter === 1 ? '' : 's'}.`
        const messageTemplate = `<div class="d-flex align-items-center" id="announcementId">
          <div class="mr-5"> <i class="fa fa-info-circle fa-2x" aria-hidden="true"></i></div>
          <div class="ml-5">
          <div>
          <span>${message}</span>
          </div> </div> </div>`
        this.currentToast = await this.showToast({
          message: messageTemplate,
          pauseOnHover: true,
          duration: 0,
          dismissible: false,
          queue: true,
        }, true, 'success', true)

        setTimeout(() => {
          this.onClickHandlerForAnnouncementModal()
        }, 2000);

      },
      onClickHandlerForAnnouncementModal(){
        const id = `#announcementId`
        console.log('this id', id)
        this.announcementElement = $(id);
        if ( this.announcementElement.length) {
          this.announcementElement.on('click', () => {
            if(this.pendingTeamAnnouncements === 1){
              this.$store.commit('mutateSingleAnnouncement', true);
            }
            this.$router.push({ name: 'communications' });
          });
        } else {
          console.log('Does not exist');
        }
      },
      getTotalDownBetterUptimeOutages(){
        console.log('calling');

        this.betteruptimeTests = [];
        let downQuery = db.collection('monitors')
          .where('status', 'in', ['down'])
          // .limit(500);

        this.downListener = downQuery.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            switch (change.type) {
              case 'added':
                this.betteruptimeTests.unshift(change.doc.data());
                this.startGrouping()
                break;
              case "removed":
              {
                const removedData = change.doc.data();
                this.betteruptimeTests = this.betteruptimeTests.filter(test => test.id !== removedData.id);
                this.startGrouping()
              }
                break;
            }
          });
        })
      },
      getPendingAnnouncements(){
        console.log('calling');

        this.pendingTeamAnnouncements = 0;
        let query = db.collection('team-announcements').doc('counter')
          // .limit(500);

        this.annListener = query.onSnapshot({
          // Listen for document metadata changes
          includeMetadataChanges: true
        }, (doc) => {
          // ...
          const { staffMembers } = doc.data();
          let obj = null;
          if (staffMembers.length) {
            obj = staffMembers.find(el => el.uid === this.user.uid);
            console.log('obj fooumd', obj)
            if (obj) {
              this.pendingTeamAnnouncements = obj.counter

            }
          }
          console.log('snapshot', doc.data())

        });
      },
      getApiErrorLogs(){
        this.apiErrorLogs = [];
        let query = db.collection('apiErrorLogs')
            .where('createdAt', '>=', moment(new Date()).subtract(1, 'days').toISOString())

        this.downListener = query.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
                this.apiErrorLogs.unshift(change.doc.data());

          });
        })
      }
    },
		beforeDestroy() {
      if (this.annListener) {
        this.annListener()
      }
			if(sidebar){
				sidebar.destroy();
			}
			sidebar = null;

      let $announcementElement = $('#announcementId');
      if ($announcementElement.length && this.onClickHandlerForAnnouncementModal) {
        $announcementElement.off('click', this.onClickHandlerForAnnouncementModal);
      }
		}
	};
</script>

<style lang="scss">
	.logo {
		min-height: 68px;
	}
  .sidebar .sidebar-wrapper, .off-canvas-sidebar .sidebar-wrapper {
    height: calc(100vh - 6px) !important;
  }
</style>
